function getCustomSignupUrl() {
	return window.ARAC_CUSTOM_SIGNUP_URL || "";
}

function redirectToCustomSignup(event) {
	const signupUrl = getCustomSignupUrl();
	if (!signupUrl) return;

	const link = event.target && event.target.closest && event.target.closest('a[href="#signup"]');
	if (!link) return;

	event.preventDefault();
	event.stopImmediatePropagation();
	window.location.href = signupUrl;
}

function redirectHashSignup() {
	const signupUrl = getCustomSignupUrl();
	if (!signupUrl || window.location.hash !== "#signup") return;

	window.location.replace(signupUrl);
}

document.addEventListener("click", redirectToCustomSignup, true);
document.addEventListener("DOMContentLoaded", redirectHashSignup);
